<div class="msm-header">
	<div class="msm-title"><i class="bi bi-camera"></i> Karte aufnehmen</div>
	<div class="msm-scale">
		Bildschirm {{ scaleText() }}
		@if (selectedScale()) {
			· <strong>Ziel 1:{{ selectedScale() }}</strong>
		}
	</div>
	<button type="button" class="btn-close" aria-label="Schließen" (click)="cancel()"></button>
</div>

<div class="msm-map" [style.aspect-ratio]="targetAspect">
	<bp-map
		[layers]="layers"
		[points]="projectMarkers.markers()"
		[pointsFilter]="projectMarkers.pointsFilter()"
		[(mapStatus)]="mapStatus"
		[visible]="true"
		[online]="true"
		[restrictedMode]="true"
		[persistentBounds]="true"
		(map$)="onMapReady($event)"
	></bp-map>
</div>

<div class="msm-presets">
	<button type="button" class="btn btn-sm btn-outline-primary" (click)="zoomToProject()" title="Auf das Projektausmaß zoomen">
		<i class="bi bi-bounding-box"></i> Projektausmaß
	</button>
	@if (mainMapView()) {
		<button type="button" class="btn btn-sm btn-outline-primary" (click)="adoptMainMapView()" title="Ausschnitt der Hauptkarte übernehmen">
			<i class="bi bi-geo-alt"></i> Aktuelle Karte
		</button>
	}
	<span class="msm-presets-label">Ziel-Druckmaßstab:</span>
	@for (p of presets; track p) {
		<button type="button" class="btn btn-sm"
			[class.btn-secondary]="selectedScale() === p"
			[class.btn-outline-secondary]="selectedScale() !== p"
			(click)="applyPreset(p)">1:{{ p }}</button>
	}
	@if (selectedScale()) {
		<button type="button" class="btn btn-sm btn-link msm-clear" (click)="selectedScale.set(null)">frei</button>
	}
</div>

@if (error()) {
	<div class="msm-error"><i class="bi bi-exclamation-triangle"></i> {{ error() }}</div>
}

<div class="msm-footer">
	<button type="button" class="btn btn-secondary" (click)="cancel()">Abbrechen</button>
	<button type="button" class="btn btn-success" (click)="capture()" [disabled]="capturing() || !ready()">
		@if (capturing()) {
			<span class="spinner-border spinner-border-sm"></span>
		} @else {
			<i class="bi bi-camera"></i>
		}
		Aufnehmen
	</button>
</div>
